import React from 'react';
import { Link } from 'react-router-dom';
import arrow_back from '../assets/images/arrow-back.svg';
import logo_pop from '../assets/images/logo-pop.png';
import EDSFooter from '../components/EDSFooter';

const Error_zajety_login = () => {
    return (
        <>
            <header className="header">
                <div className="header__image-box">
                    <a href="">
                        <img
                            src={logo_pop}
                            alt="Logo Egurrola Dance Studio"
                            className="header__image"
                        />
                    </a>
                </div>
                <div className="header__caption-box">
                    <span className="header__caption">Proces zakupu kursu</span>
                </div>
            </header>
            <div className="content responsive-padding">
                <div className="margin-top-32" style={{ display: 'none' }}>
                    <a href="">
                        <img src={arrow_back} alt="arrow_back" className="arrow-back" />
                    </a>
                </div>
                <main className="margin-top-64">
                    <div className="texts text-box">
                        <h2 className="h2">Zajęty adres e-mail.</h2>
                        <p className="margin-top-16">
                            Konto dla podanego adresu e-mail już istnieje w&nbsp;naszej bazie.
                        </p>
                        <p className="text-large fw-700 margin-top-64">Możesz spróbować:</p>
                        <div className="margin-top-32">
                            <p className="text-large">1. Odzyskać konto.</p>
                            <Link to="/Odzyskaj_konto">
                                <a href="" className="btn-primary-responsive margin-top-16">
                                    Odzyskaj konto
                                </a>
                            </Link>
                        </div>
                        <div className="margin-top-64">
                            <p className="text-large">2. Wypełnić formularz jeszcze raz.</p>
                            <Link to="/Rejestracja_dane">
                                <a href="" className="btn-primary-responsive margin-top-16">
                                    Wróć do formularza
                                </a>
                            </Link>
                        </div>
                        <div className="margin-top-64">
                            <p className="text-large">
                                3. Skontaktować się z Infolinią by wyjaśnić rozbieżności.
                            </p>
                            <h2 className="h2 margin-top-16">INFOLINIA</h2>
                            <p className="margin-top-8">czynna od poniedziałku do piątku</p>
                            <p>w godzinach 9:00 - 17:00</p>
                            <p className="margin-top-16">tel.: 601 20 20 20</p>
                            <p>e-mail: studio@egurrola.pl</p>
                        </div>
                        <Link to="/">
                            <a
                                href=""
                                className="btn-secondary-responsive btn-secondary-responsive--medium margin-top-64  margin-bottom-32"
                            >
                                Wróć do strony głównej
                            </a>
                        </Link>
                    </div>
                </main>
            </div>
            <EDSFooter></EDSFooter>
        </>
    );
};
export default Error_zajety_login;
